import { useContext, useEffect, useState } from "react";
import { IPanelRosterEditar } from './PanelRosterActualizar';
import { codigosRespuesta, IResponseApiFluent } from "../../../../interfaces/base/IResponse";
import { IRoster } from "../../../../interfaces/IRoster";
import RosterService from "../../../../services/rosterService";
import { AuthContext } from '../../../../auth/context/auth-context';


const UseRosterActualizar = (props: IPanelRosterEditar) => {
   const { access } = useContext(AuthContext);
   const [status, setStatus] = useState<codigosRespuesta>(0);
   const [mensaje, setMensaje] = useState<string>("");
   const [loading, setLoading] = useState<boolean>(false)
   const [buttonSalir, setButtonSalir] = useState<boolean>(false)
   const initial: IRoster = {
      id: "",
      codigo: "",
      diasLaborables: null,
      diasDescanso: null,
      isGuardia: false,
      regimen: "",
      guardia: "",
      dia: false,
      noche: false,
      created: "",
      usuario: "",
      turnoDia: "",
      turnoNoche: "",
   }
   const [command, setCommand] = useState<IRoster>(initial)
   const [disableForm, setDisableForm] = useState<boolean>(true);

   const putEditarRoster = () => {
      setLoading(true)
      RosterService.crearRoster(command)
         .then((res) => {
            if (res.status == 200) {
               setStatus(200)
               setMensaje(res.data.mensaje);
               setTimeout(() => {
                  props.reload?.();
                  reset()
               }, 3000)
            } else {
               setStatus(500)
            }
            setLoading(false)

         }).catch((e) => {
            if (
               e.response?.data &&
               'type' in e.response.data &&
               'title' in e.response.data &&
               'status' in e.response.data &&
               'instance' in e.response.data &&
               'errors' in e.response.data
            ) {
               const errorResponse = e.response.data as IResponseApiFluent;
               const mensajeError = errorResponse.errors.join('\n');
               setButtonSalir(true)
               setMensaje(mensajeError);

            } else {
               setMensaje("Error Inesperado");
            }
            setStatus(500);
            setLoading(false);
         })
   }

   const reset = () => {
      setMensaje("")
      setCommand(initial)
      setStatus(0)
      props.onDismiss()
   }


   let required: (keyof IRoster)[] = [
      "codigo",
   ];

   if (!access?.role?.includes("Admin")) {
      required = [
         "codigo",
         "diasLaborables",
         "diasDescanso",
         "guardiaProgramacionId"
      ]
   }

   useEffect(() => {
      if (props.isOpen) {
         setCommand({
            ...command,
            id: props.rosterData.id,
            codigo: props.rosterData.codigo,
            diasLaborables: props.rosterData.diasLaborables,
            diasDescanso: props.rosterData.diasDescanso,
            guardiaProgramacionId: props.rosterData.guardiaProgramacionId,
            dia: props.rosterData.dia,
            noche: props.rosterData.noche,
         })
      }
   }, [props.isOpen])

   useEffect(() => {
      const check = required.every((field) => {
         const value = command[field];
         return value !== null && value !== undefined && value !== "";
      });
      setDisableForm(!check)
   }, [command])

   return { command, setCommand, putEditarRoster, loading, setLoading, reset, mensaje, setMensaje, status, disableForm, buttonSalir }
}

export { UseRosterActualizar }